import BodyText from 'LuxKit/Typography/BodyText'
import { useContext, useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
import VerticalSpacer from '../Spacing/VerticalSpacer'
import { rem } from 'polished'
import { TrustPilotStars } from '../TrustIndicators/TrustPilotStars'
import IconButton from 'LuxKit/Button/IconButton'
import LineAngleLeftIcon from 'LuxKit/Icons/line/LineAngleLeftIcon'
import LineAngleRightIcon from 'LuxKit/Icons/line/LineAngleRightIcon'
import GeoContext from 'contexts/geoContext'

type RegionalAuthor = {
  default: string
  [key: string]: string | undefined
}

type Review = {
  id: number
  title: string
  content: string
  author: RegionalAuthor
  link: string
}

const TRUSTPILOT_URL = 'https://au.trustpilot.com/review/luxuryescapes.com'

const reviews: Array<Review> = [
  {
    id: 1,
    title: '4th trip, great prices',
    content:
      '3 years, 4th trip great prices, great service always helpful shout out to Gemma E very helpful, fast response',
    author: {
      default: 'Peter W.',
      SG: 'James Tan',
      HK: 'Sarah Yuen',
    },
    link: TRUSTPILOT_URL,
  },
  {
    id: 2,
    title: 'We have just returned from The Haven in…',
    content:
      'We have just returned from The Haven in Khao Lak in Phuket. Wendy P. was our agent from Luxury Escapes and did a fabulous job for us. The trip went very well the hotel and package was amazing. The hotel staff were all very helpful and supportive. Great holiday - thanks LE.',
    author: {
      default: 'Fiona W.',
      SG: 'Jessica Lui',
      HK: 'Mei Ling Cheng',
    },
    link: TRUSTPILOT_URL,
  },
  {
    id: 3,
    title: 'Great service!',
    content:
      'I have just returned from my first holiday where I was astounded by the value for money, so on my return I went straight back online to book my next break. Excellent service received from Joel S today when I needed to amend my second booking. Happy days!',
    author: {
      default: 'Cate B.',
      SG: 'William Ong',
      HK: 'Sze Mei Ho',
    },
    link: TRUSTPILOT_URL,
  },
  {
    id: 4,
    title: 'Really appreciate the wonderful service',
    content:
      'Really appreciate the wonderful service and advice from Stephanie at Luxury Escapes! I was so well looked after - and now my husband and I have a well thought out holiday to look forward to!! Thank you Steph and Luxury Escapes- we cannot wait!!!',
    author: {
      default: 'Juliana C.',
      SG: 'Rahul Shankar',
      HK: 'Jessica Man',
    },
    link: TRUSTPILOT_URL,
  },
  {
    id: 5,
    title: 'We love Luxury Escapes',
    content:
      'Kurniawan C. was so helpful, my request was confirmed within 15 minutes and I could not be more grateful. He was very kind and professional. This is why we love Luxury Escapes',
    author: {
      default: 'Brady B.',
      SG: 'Alexander Lim',
      HK: 'David Wong',
    },
    link: TRUSTPILOT_URL,
  },
  {
    id: 6,
    title: 'Gemma was so helpful with my enquire…',
    content:
      'Gemma was so helpful with my enquire and followed up everything, calling me back three times to make sure all was good. Could not be happier with her service.',
    author: {
      default: 'Paul P.',
      SG: 'Melissa Wong',
      HK: 'Chun Hei Chan',
    },
    link: TRUSTPILOT_URL,
  },
  {
    id: 7,
    title: 'Great customer experience',
    content:
      'Great customer experience, Emily G was so respectful, friendly and help me with my inquiries in a very good manner. Was a pleasure talking to her, well done 👏 Luxury Escapes and Emily G.',
    author: {
      default: 'Jean L.',
      SG: 'Nicole Lee',
      HK: 'Olivia Chung',
    },
    link: TRUSTPILOT_URL,
  },
  {
    id: 8,
    title: 'Dealing with great staff is a bonus and…',
    content:
      'Dealing with great staff is a bonus and Sarah B is amazing nothing was any trouble she is a pleasure to deal with 10/10. Being we had to cancel our trip Sarah was very efficient and understanding of our circumstances and being as we have book through Luxury Escapes before and have had amazing holiday’s in the past this is just a hiccup before we book our next trip.',
    author: {
      default: 'Karen T.',
      SG: 'Olivia Chew',
      HK: 'Yee Ling Wong',
    },
    link: TRUSTPILOT_URL,
  },
  {
    id: 9,
    title: 'Sarah T was very helpful',
    content:
      'Sarah T was very helpful. After few phone call with different agents, Sarah was able to sort out my issue. She actually rang me back to finalize everything and ensure everything is sorted. Great customer service. Well done Luxury Escapes',
    author: {
      default: 'Amal H.',
      SG: 'Hannah Ang',
      HK: 'Victoria Lui',
    },
    link: TRUSTPILOT_URL,
  },
  {
    id: 10,
    title: 'Great deals and five star service',
    content:
      'Great deals and five star service. Had to make a change to my booking and Joel S was very helpful and very efficient. Will always use Luxury Escapes for all future bookings.',
    author: {
      default: 'Vicky C.',
      SG: 'Marcus Koh',
      HK: 'Andrew Chan',
    },
    link: TRUSTPILOT_URL,
  },
]
const CarouselContainer = styled.div`
  width: 100%;
  max-width: ${rem(600)};
  overflow: hidden;
  position: relative;
  margin: auto;
  padding-bottom: ${rem(5)};
`

const Track = styled.div`
  display: grid;
  grid-template-columns: repeat(${reviews.length}, 100%);
  width: 100%;
  transition: transform 0.5s ease-in-out;
  margin-bottom: ${rem(16)};
  cursor: pointer;
`

const ReviewCard = styled.div`
  padding: 0 ${rem(6)};
  text-align: left;
`

const NavigationContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${rem(12)};
  margin-top: ${rem(12)};
`

const ArrowButton = styled(IconButton)`
  width: ${rem(28)};
  height: ${rem(28)};
  transition: color 0.2s, background-color 0.2s, border-color 0.2s, opacity 0.2s;
`

const DotsContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: ${rem(8)};
`

const Dot = styled.button`
  width: ${rem(8)};
  height: ${rem(8)};
  border-radius: 50%;
  background: ${({ theme }) => theme.palette.neutral.default.five};
  border: none;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  margin: 0;

  &.active {
    transform: scale(1.5);
    background: ${({ theme }) => theme.palette.neutral.default.one};
  }
`

const autoScrollSpeed = 5000

function TrustPilotCarousel() {
  const { currentRegionCode } = useContext(GeoContext)
  const [index, setIndex] = useState(0)
  const timeoutRef = useRef<NodeJS.Timeout | null>(null)

  const handleClick = (link: string) => {
    window.open(link, '_blank')
  }

  const handleDotClick = (i: number) => {
    setIndex(i)
    resetAutoScroll()
  }

  const goPrev = () => {
    setIndex((prev) => Math.max(prev - 1, 0))
    resetAutoScroll()
  }

  const goNext = () => {
    setIndex((prev) => Math.min(prev + 1, reviews.length - 1))
    resetAutoScroll()
  }
  const resetAutoScroll = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)
    }
    startAutoScroll()
  }

  const startAutoScroll = () => {
    timeoutRef.current = setTimeout(() => {
      setIndex((prev) => (prev + 1) % reviews.length)
    }, autoScrollSpeed)
  }

  useEffect(() => {
    startAutoScroll()
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
      }
    }
  }, [index])

  return (
    <CarouselContainer>
      <Track style={{ transform: `translateX(-${index * 100}%)` }}>
        {reviews.map((review) => (
          <ReviewCard key={review.id} onClick={() => handleClick(review.link)}>
            <VerticalSpacer gap={12}>
              <TrustPilotStars width="76" height="14" />
              <BodyText weight="bold" variant="medium" colour="primary-dark">
                {review.title}
              </BodyText>
            </VerticalSpacer>
            <VerticalSpacer gap={12}>
              <BodyText variant="medium" lineClamp={3}>{review.content}</BodyText>
              <BodyText variant="medium" colour="neutral-three">
                {review.author[currentRegionCode] ?? review.author.default}
              </BodyText>
            </VerticalSpacer>
          </ReviewCard>
        ))}
      </Track>
      <NavigationContainer>
        <ArrowButton
          kind="secondary"
          shape="circle"
          onClick={goPrev}
          disabled={index === 0}
        ><LineAngleLeftIcon />
        </ArrowButton>
        <DotsContainer>
          {reviews.map((_, i) => (
            <Dot key={i} className={index === i ? 'active' : ''} onClick={() => handleDotClick(i)} />
          ))}
        </DotsContainer>
        <ArrowButton
          kind="secondary"
          size="small"
          shape="circle"
          onClick={goNext}
          disabled={index === reviews.length - 1}
        ><LineAngleRightIcon />
        </ArrowButton>
      </NavigationContainer>
    </CarouselContainer>
  )
}

export default TrustPilotCarousel
